var map = {
	"./bialystok/podatek-od-nieruchomosci/section-1_pl.mdx": [
		72906,
		72906
	],
	"./bydgoszcz/podatek-od-nieruchomosci/section-1_pl.mdx": [
		54487,
		54487
	],
	"./czestochowa/podatek-od-nieruchomosci/section-1_pl.mdx": [
		93708,
		93708
	],
	"./garwolin/podatek-od-nieruchomosci/section-1_pl.mdx": [
		47513,
		47513
	],
	"./gdansk/podatek-od-nieruchomosci/section-1_pl.mdx": [
		67322,
		67322
	],
	"./gdynia/podatek-od-nieruchomosci/section-1_pl.mdx": [
		25562,
		25562
	],
	"./gliwice/podatek-od-nieruchomosci/section-1_pl.mdx": [
		32914,
		32914
	],
	"./gmina-swidnica/podatek-od-nieruchomosci/section-1_pl.mdx": [
		65085,
		65085
	],
	"./kielce/podatek-od-nieruchomosci/section-1_pl.mdx": [
		22419,
		22419
	],
	"./kolobrzeg/podatek-od-nieruchomosci/section-1_pl.mdx": [
		70577,
		70577
	],
	"./konskowola/podatek-od-nieruchomosci/section-1_pl.mdx": [
		97290,
		97290
	],
	"./koszalin/podatek-od-nieruchomosci/section-1_pl.mdx": [
		42939,
		42939
	],
	"./lask/podatek-od-nieruchomosci/section-1_pl.mdx": [
		87551,
		87551
	],
	"./lodz/podatek-od-nieruchomosci/section-1_pl.mdx": [
		60557,
		60557
	],
	"./lublin/podatek-od-nieruchomosci/section-1_pl.mdx": [
		15434,
		15434
	],
	"./miejsce-piastowe/podatek-od-nieruchomosci/section-1_pl.mdx": [
		71825,
		71825
	],
	"./mikolow/podatek-od-nieruchomosci/section-1_pl.mdx": [
		50618,
		50618
	],
	"./naklo/podatek-od-nieruchomosci/section-1_pl.mdx": [
		58777,
		58777
	],
	"./oborniki/podatek-od-nieruchomosci/section-1_pl.mdx": [
		3067,
		3067
	],
	"./olesnica/podatek-od-nieruchomosci/section-1_pl.mdx": [
		41778,
		41778
	],
	"./postomino/podatek-od-nieruchomosci/section-1_pl.mdx": [
		7334,
		7334
	],
	"./poznan/podatek-od-nieruchomosci/section-1_pl.mdx": [
		25774,
		25774
	],
	"./przechlewo/podatek-od-nieruchomosci/section-1_pl.mdx": [
		53019,
		53019
	],
	"./radom/podatek-od-nieruchomosci/section-1_pl.mdx": [
		93977,
		93977
	],
	"./raszkow/podatek-od-nieruchomosci/section-1_pl.mdx": [
		2717,
		2717
	],
	"./rawicz/podatek-od-nieruchomosci/section-1_pl.mdx": [
		94248,
		94248
	],
	"./ryman/podatek-od-nieruchomosci/section-1_pl.mdx": [
		42933,
		42933
	],
	"./sierakowice/podatek-od-nieruchomosci/section-1_pl.mdx": [
		50668,
		50668
	],
	"./slawno/podatek-od-nieruchomosci/section-1_pl.mdx": [
		74244,
		74244
	],
	"./slawoborze/podatek-od-nieruchomosci/section-1_pl.mdx": [
		29614,
		29614
	],
	"./stare-babice/podatek-od-nieruchomosci/section-1_pl.mdx": [
		50462,
		50462
	],
	"./szczecin/podatek-od-nieruchomosci/section-1_pl.mdx": [
		20925,
		20925
	],
	"./szemud/podatek-od-nieruchomosci/section-1_pl.mdx": [
		64278,
		64278
	],
	"./warszawa/podatek-od-nieruchomosci/section-1_pl.mdx": [
		9402,
		9402
	],
	"./wloszczowa/podatek-od-nieruchomosci/section-1_pl.mdx": [
		40407,
		40407
	],
	"./wroclaw/podatek-od-nieruchomosci/section-1_pl.mdx": [
		44503,
		44503
	],
	"./wyszkow/podatek-od-nieruchomosci/section-1_pl.mdx": [
		53712,
		53712
	],
	"./zukowo/podatek-od-nieruchomosci/section-1_pl.mdx": [
		65323,
		65323
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 38087;
module.exports = webpackAsyncContext;